/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-magic-numbers */
import generatedGitInfo from './generatedGitInfo.json';

const AUTH_BASE_URL = import.meta.env.VITE_AUTH_BASE_URL as string;
const BASE_MEDIA_URL = import.meta.env.VITE_BASE_MEDIA_URL as string;
const BASE_OTA_MEDIA_URL = import.meta.env.VITE_BASE_OTA_MEDIA_URL as string;
const BASE_DOUBT_SOLVER_URL = import.meta.env.VITE_DOUBT_SOLVER_URL as string;
const BASE_QUESTION_MEDIA_URL = import.meta.env.VITE_BASE_QUESTION_MEDIA_URL as string;
const BASE_QUESTION_CONTENT_URL = import.meta.env.VITE_BASE_QUESTION_CONTENT_URL as string;
const BASE_APP_URL = import.meta.env.VITE_BASE_APP_URL as string;
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT as string;

const GET_SERVER_TIME_URL = `${AUTH_BASE_URL}/auth/get-server-time`;
const APP_VERSION = generatedGitInfo.version_code;
const GIT_INFO = `${generatedGitInfo.gitBranch}-${generatedGitInfo.gitCommitHash}`;

const VALIDATE_CENTER_URL = `${AUTH_BASE_URL}/admin/auth/validate-center`;
const ADMIN_LOGIN_URL = `${AUTH_BASE_URL}/admin/auth/login`;
const REFRESH_TOKEN_URL = `${AUTH_BASE_URL}/admin/auth/get-device-access-token`;
const ADMIN_LOGOUT_URL = `${AUTH_BASE_URL}/admin/auth/logout`;
const GET_ADMIN_DETAILS = `${AUTH_BASE_URL}/admin/program/get-details`;
const SUBMIT_ADMIN_FEEDBACK = `${AUTH_BASE_URL}/admin/support/v2/submit-feedback`;
const RESET_APP = `${AUTH_BASE_URL}/admin/auth/reset-app`;

const GET_GRADES_URL = `${AUTH_BASE_URL}/student/program/get-grades`;
const GET_STUDENTS_URL = `${AUTH_BASE_URL}/student/center/get-students-by-grade`;
const GET_STUDENT_DETAILS = `${AUTH_BASE_URL}/student/program/get-details`;

const SET_STUDENT_PASSWORD_URL = `${AUTH_BASE_URL}/student/auth/set-password`;
const CHECK_PASSWORD_URL = `${AUTH_BASE_URL}/student/auth/check-password`;
const LOGIN_STUDENT_URL = `${AUTH_BASE_URL}/student/auth/login`;
const GET_RESET_PASSWORD_TOKEN_URL = `${AUTH_BASE_URL}/student/auth/get-reset-password-token`;
const RESET_PASSWORD_URL = `${AUTH_BASE_URL}/student/auth/reset-password`;

const GET_INSTRUCTIONS_URL = `${AUTH_BASE_URL}/student/assessment/get-instructions`;
const CHECK_AVAILABILITY_URL = `${AUTH_BASE_URL}/student/assessment/check-availability`;
const INITIATE_TEST_URL = `${AUTH_BASE_URL}/student/assessment/initiate`;
const REJOIN_TEST_URL = `${AUTH_BASE_URL}/student/assessment/rejoin`;
const SUBMIT_RESPONSE_URL = `${AUTH_BASE_URL}/student/assessment/submit-response`;
const SUBMIT_ASSESSMENT_URL = `${AUTH_BASE_URL}/student/assessment/submit`;
const ABORT_ASSESSMENT_URL = `${AUTH_BASE_URL}/student/assessment/abort`;
const GET_STUDENT_INFO = `${AUTH_BASE_URL}/student/info`;
const SUBMIT_STUDENT_FEEDBACK = `${AUTH_BASE_URL}/student/support/v2/submit-feedback`;
const GET_AT_HOME_ACCESS_CODE_URL = `${AUTH_BASE_URL}/student/get-at-home-access-code`;

const GET_SUBJECT_LIST_URL = `${AUTH_BASE_URL}/student/learn/get-subject-list`;
const GET_LEVEL_LIST_URL = `${AUTH_BASE_URL}/student/learn/get-level-list`;
const GET_MISSION_LIST_URL = `${AUTH_BASE_URL}/student/learn/get-mission-list`;
const GET_STAGE_LIST_URL = `${AUTH_BASE_URL}/student/learn/get-stage-list`;
const GET_MODULE_LIST_URL = `${AUTH_BASE_URL}/student/learn/get-module-list`;
const ADD_MODULE_STATS_URL = `${AUTH_BASE_URL}/student/learn/add-module-stats`;
const GET_MODULE_QUESTIONS_URL = `${AUTH_BASE_URL}/student/learn/get-module-questions`;

const GET_STATS_URL = `${AUTH_BASE_URL}/student/cueing-engine/get-stats`;
const GET_QUESTIONS_URL = `${AUTH_BASE_URL}/student/cueing-engine/get-questions`;
const SUBMIT_RESULT_URL = `${AUTH_BASE_URL}/student/cueing-engine/submit-result`;

const GET_PRACTICE_CONTENT_URL = `${AUTH_BASE_URL}/student/practice/get-content`;
const SUBMIT_PRACTICE_RESULT_URL = `${AUTH_BASE_URL}/student/practice/submit-result`;

const GET_STUDENT_CARDS = `${AUTH_BASE_URL}/student/get-subject-card-map`;
const GET_MONSTERS_CARDS = `${AUTH_BASE_URL}/student/get-monster-card-map`;
const GET_STUDENT_MONSTER_CARDS = `${AUTH_BASE_URL}/student/monster-cards`;
const GET_STUDENT_SUBJECT_CARDS = `${AUTH_BASE_URL}/student/subject-cards`;

const GET_MEDIA_ACCESS_TOKEN_URL = `${AUTH_BASE_URL}/student/auth/get-media-access-token`;
const GET_MODULE_DETAILS_URL = `${AUTH_BASE_URL}/student/content/get-module-details`;
const GET_OFFLINE_ENCRYPTION_KEY_URL = `${AUTH_BASE_URL}/content/get-offline-encryption-key`;
const OFFLINE_DESKTOP_PROTOCOL_NAME = 'fusion-offline';
const ONLINE_DESKTOP_PROTOCOL_NAME = 'fusion-online';
const ONLINE_QUESTION_DESKTOP_PROTOCOL_NAME = 'fusion-question-online';
const ONLINE_HTML_DESKTOP_PROTOCOL_NAME = 'fusion-html-online';
const OFFLINE_HTML_DESKTOP_PROTOCOL_NAME = 'fusion-html-offline';
/** Unencrypted HTML question content protocols (offline-first, online fallback). */
const ONLINE_QUESTION_HTML_DESKTOP_PROTOCOL_NAME = 'fusion-question-html-online';
const OFFLINE_QUESTION_HTML_DESKTOP_PROTOCOL_NAME = 'fusion-question-html-offline';
/** Web app: same-origin path prefix for interactive HTML content (mirrors fusion-html-online://html/) */
const WEB_HTML_CONTENT_PATH_PREFIX = '/fusion-html-online/html';

const CONTENT_REPORT_URL = `${AUTH_BASE_URL}/student/content-report`;
const VERIFY_AT_HOME_ACCESS_CODE_URL = `${AUTH_BASE_URL}/student/auth/verify-at-home-access-code`;
const GET_STUDENT_BY_ACCESS_TOKEN_URL = `${AUTH_BASE_URL}/student/at-home/get-student-by-access-token`;
const GET_STUDENT_BY_MOBILE = `${AUTH_BASE_URL}/student/at-home/get-students-by-mobile`;
const SEND_OTP_URL = `${AUTH_BASE_URL}/mobile/auth/send-otp`;
const VERIFY_OTP_URL = `${AUTH_BASE_URL}/mobile/auth/verify-otp`;
const RESET_APP_URL = `${AUTH_BASE_URL}/student/auth/reset-app`;
const STUDENT_REFRESH_TOKEN_URL = `${AUTH_BASE_URL}/student/auth/get-device-access-token`;
const GET_CARROT_URL = `${AUTH_BASE_URL}/student/carrot/get-carrot`;
const CARROT_STATS_URL = `${AUTH_BASE_URL}/student/carrot/stats`;

const GET_LEADERBOARD_URL = `${AUTH_BASE_URL}/student/coin/leaderboard`;

const GET_ACTIVITIES_URL = `${AUTH_BASE_URL}/student/activities/get-activity`;
const INITIALIZE_ACTIVITY_URL = `${AUTH_BASE_URL}/student/activities/initialize`;
const ACTIVITY_STATS_BASE_URL = `${AUTH_BASE_URL}/student/activities/stats`;
const GET_ACTIVITY_MODULES_BASE_URL = `${AUTH_BASE_URL}/student/activities`;
const GET_SESSION_SEGMENTS_BASE_URL = `${AUTH_BASE_URL}/student/sessions`;
const GET_SEGMENT_CONTENT_URL = `${AUTH_BASE_URL}/student/activities/get-segment-content`;
const GET_CERTIFICATES_URL = `${AUTH_BASE_URL}/student/activities/certificates`;

// OTA Update URLs
const GET_OFFLINE_ZIP_UPDATES_URL = `${AUTH_BASE_URL}/admin/content/get-offline-zip-updates`;
const GET_OFFLINE_ZIP_UPDATE_DETAILS_URL = `${AUTH_BASE_URL}/admin/content/get-offline-zip-update-details`;

// Admin Learn & Assessment URLs
const ADMIN_GET_SUBJECT_LIST_URL = `${AUTH_BASE_URL}/admin/learn/get-subject-list`;
const ADMIN_GENERATE_CODE_URL = `${AUTH_BASE_URL}/admin/assessment/generate-code`;

const SEND_MESSAGE_URL = `${AUTH_BASE_URL}/doubt-solver/send-message`;
const GET_FOLLOW_UP_QUESTION = `${AUTH_BASE_URL}/doubt-solver/get-follow-up-question`;

const SPLASH_SCREEN_TIME = 2000;
const AUTO_LOGOUT_TIME = 900e3;

const FAQ_URL = 'https://convegeniusglobal.zohodesk.com/portal/en/kb/bei';
const CUSTOMER_SUPPORT_URL = 'https://convegeniusglobal.zohodesk.com/portal/en/newticket';
const DESKTOP_GA_API_SECRET_KEY: string = import.meta.env.VITE_DESKTOP_GA_API_SECRET_KEY;
const DESKTOP_GA_MEASUREMENT_ID: string = import.meta.env.VITE_DESKTOP_GA_MEASUREMENT_ID;
const UBUNTU_GA_API_SECRET_KEY: string =
  import.meta.env.VITE_UBUNTU_GA_API_SECRET_KEY || DESKTOP_GA_API_SECRET_KEY;
const UBUNTU_GA_MEASUREMENT_ID: string =
  import.meta.env.VITE_UBUNTU_GA_MEASUREMENT_ID || DESKTOP_GA_MEASUREMENT_ID;

const NUDGE_TRIGGERS = {
  LANDING_SCREEN_IMPRESSION: 'T1',
  FORMATIVE_QUESTION_RENDER: 'T1',
  FORMATIVE_POST_ANSWER_WRONG: 'T2',
  EVALUATIVE_QUESTION_RENDER: 'T1',
  EVALUATIVE_POST_SUBMIT: 'T2',
  VIDEO_PROGRESS_EVENT: 'T1',
  PRACTICE_QUESTION_RENDER: 'T1',
  PRACTICE_STAGE_RESULT: 'T2',
} as const;

const NUDGE_EVENT_NAMES = {
  MISSION_PRACTICED: 'mission_practiced',
  STAGE_STARTED: 'stage_started',
  STAGE_EXITED: 'stage_exited',
  VIDEO_COMPLETED: 'video_completed',
  CUEING_STARTED: 'cueing_started',
  HINT_CLICKED: 'hint_clicked',
  CUEING_COMPLETED: 'cueing_completed',
  CUEING_FAILED: 'cueing_failed',
  QUESTION_ANSWERED: 'question_answered',
  STUDENT_LOG_OUT: 'student_log_out',
} as const;

// Param keys on a nudging event: LABEL = was-correct, VALUE = hint-used (both booleans).
const NUDGE_EVENT_PARAMETERS = {
  LABEL: 'label',
  VALUE: 'value',
} as const;

export default {
  BASE_OTA_MEDIA_URL,
  BASE_DOUBT_SOLVER_URL,
  AUTH_BASE_URL,
  BASE_MEDIA_URL,
  BASE_QUESTION_MEDIA_URL,
  NUDGE_TRIGGERS,
  NUDGE_EVENT_NAMES,
  NUDGE_EVENT_PARAMETERS,
  BASE_QUESTION_CONTENT_URL,
  CONNECTION_TIMEOUT: 1.25 * 60 * 1000,
  VALIDATE_CENTER_URL,
  ADMIN_LOGIN_URL,
  GET_GRADES_URL,
  GET_STUDENTS_URL,
  SET_STUDENT_PASSWORD_URL,
  CHECK_PASSWORD_URL,
  LOGIN_STUDENT_URL,
  GET_RESET_PASSWORD_TOKEN_URL,
  RESET_PASSWORD_URL,
  REFRESH_TOKEN_URL,
  ADMIN_LOGOUT_URL,
  SPLASH_SCREEN_TIME,
  GET_SUBJECT_LIST_URL,
  GET_INSTRUCTIONS_URL,
  CHECK_AVAILABILITY_URL,
  INITIATE_TEST_URL,
  REJOIN_TEST_URL,
  SUBMIT_RESPONSE_URL,
  SUBMIT_ASSESSMENT_URL,
  ABORT_ASSESSMENT_URL,
  GET_LEVEL_LIST_URL,
  GET_MISSION_LIST_URL,
  GET_STAGE_LIST_URL,
  GET_MODULE_LIST_URL,
  ADD_MODULE_STATS_URL,
  GET_MODULE_QUESTIONS_URL,
  GET_STATS_URL,
  GET_QUESTIONS_URL,
  SUBMIT_RESULT_URL,
  SUBMIT_PRACTICE_RESULT_URL,
  GET_PRACTICE_CONTENT_URL,
  GET_SERVER_TIME_URL,
  GET_STUDENT_INFO,
  SUBMIT_STUDENT_FEEDBACK,
  GET_AT_HOME_ACCESS_CODE_URL,
  GET_ADMIN_DETAILS,
  GET_STUDENT_DETAILS,
  SUBMIT_ADMIN_FEEDBACK,
  RESET_APP,
  AUTO_LOGOUT_TIME,
  GET_MEDIA_ACCESS_TOKEN_URL,
  GET_MODULE_DETAILS_URL,
  FAQ_URL,
  CUSTOMER_SUPPORT_URL,
  BASE_APP_URL,
  APP_VERSION,
  GIT_INFO,
  ENVIRONMENT,
  GET_OFFLINE_ENCRYPTION_KEY_URL,
  OFFLINE_DESKTOP_PROTOCOL_NAME,
  ONLINE_DESKTOP_PROTOCOL_NAME,
  ONLINE_QUESTION_DESKTOP_PROTOCOL_NAME,
  ONLINE_HTML_DESKTOP_PROTOCOL_NAME,
  OFFLINE_HTML_DESKTOP_PROTOCOL_NAME,
  ONLINE_QUESTION_HTML_DESKTOP_PROTOCOL_NAME,
  OFFLINE_QUESTION_HTML_DESKTOP_PROTOCOL_NAME,
  WEB_HTML_CONTENT_PATH_PREFIX,
  GET_STUDENT_CARDS,
  GET_MONSTERS_CARDS,
  GET_STUDENT_MONSTER_CARDS,
  GET_STUDENT_SUBJECT_CARDS,
  CONTENT_REPORT_URL,
  VERIFY_AT_HOME_ACCESS_CODE_URL,
  GET_STUDENT_BY_ACCESS_TOKEN_URL,
  GET_STUDENT_BY_MOBILE,
  SEND_OTP_URL,
  VERIFY_OTP_URL,
  RESET_APP_URL,
  STUDENT_REFRESH_TOKEN_URL,
  DESKTOP_GA_API_SECRET_KEY,
  DESKTOP_GA_MEASUREMENT_ID,
  UBUNTU_GA_API_SECRET_KEY,
  UBUNTU_GA_MEASUREMENT_ID,
  GET_OFFLINE_ZIP_UPDATES_URL,
  GET_OFFLINE_ZIP_UPDATE_DETAILS_URL,
  ADMIN_GET_SUBJECT_LIST_URL,
  ADMIN_GENERATE_CODE_URL,
  SEND_MESSAGE_URL,
  GET_FOLLOW_UP_QUESTION,
  GET_CARROT_URL,
  CARROT_STATS_URL,
  GET_ACTIVITIES_URL,
  INITIALIZE_ACTIVITY_URL,
  ACTIVITY_STATS_BASE_URL,
  GET_ACTIVITY_MODULES_BASE_URL,
  GET_SESSION_SEGMENTS_BASE_URL,
  GET_SEGMENT_CONTENT_URL,
  GET_LEADERBOARD_URL,
  GET_CERTIFICATES_URL,
};
